import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import classNames from 'classnames'

import withStyles from '@material-ui/core/styles/withStyles'
import Toggle from '../Toggle/Toggle'
import CheckBox from '../../organisms/CheckBox'
import PasswordWithRetype from '../../organisms/PasswordWithRetype'
import TextInputField from '../../organisms/TextInputField'
import DropDown from '../DropDown'
import SmallButton from '../SmallButton'
import { UNIT } from '../../../assets/styles/theme'
import RatingField from '../../organisms/RatingField'
import Signature from '../../organisms/Signature'
import ConnexusLabels from '../../../constants/ConnexusLabels'
import IntlUtil from '../../../utils/IntlUtil'
import PageData from '../../../utils/PageData'

class FormElement extends Component {
  state = {}

  _ref

  static getDerivedStateFromProps({ data, externalError }, prevState) {
    let type

    if (typeof data === 'string') {
      type = 'textLine'
    } else if (typeof data === 'function') {
      type = 'component'
    } else {
      type = data.type
    }

    const isInvalid = externalError ? { isInvalid: true } : {}

    return { type, ...isInvalid, externalError }
  }

  render() {
    const { data, classes, externalError, size, ...otherProps } = this.props
    const value = this.props.value || data.value
    const { type, isInvalid } = this.state
    let ElementComponent
    let elementProps = {
      className: classes.element,
      value,
      invalid: isInvalid,
      errorText: isInvalid && externalError,
      onFocus: this._handleFieldFocus,
      innerRef: ref => (this._ref = ref),
      'data-testid': `form-element-${data.id || data.name || ''}`,
    }

    switch (type) {
      case 'component':
        return data()

      case 'textLine':
        return <Typography className={classes.textLine}>{data}</Typography>

      case 'label':
        return <Typography className={classes.textLine}>{data.value}</Typography>

      case 'smallButton':
        return (
          <SmallButton
            text={data.placeholder}
            href={data.to}
            onClick={data.onClick}
            icon={data.icon}
            disabled={data.disabled}
            className={classNames(classes.smallButton, data.className)}
          />
        )

      case 'spacing':
        ElementComponent = 'div'
        elementProps = { style: { height: UNIT } }
        break

      case 'enum':
        ElementComponent = DropDown
        elementProps.label = data.placeholder
        elementProps.id = data.id
        elementProps.displayEmpty = data.displayEmpty
        elementProps.enumData = data.data
        elementProps.required = data.required
        elementProps.errorText = data.errorText
        break

      case 'boolean':
        ElementComponent = Toggle
        elementProps.label = data.placeholder
        elementProps.id = data.id
        elementProps.captions = data.data
        break

      case 'checkBox':
      case 'checkbox':
        ElementComponent = CheckBox
        elementProps.id = data.id
        elementProps.text = data.placeholder
        elementProps.required = data.required
        elementProps.errorText = data.errorText
        elementProps.hideStar = data.hideStar || false
        break

      case 'passwordWithRetype':
        const { settings: { technical: { passwordPatterns, passwordConditions } = {} } = {} } =
          PageData.appFrame || {}

        ElementComponent = PasswordWithRetype
        elementProps.data = {
          ...data,
          patternLabels: passwordConditions,
          passwordStrength: {
            text: IntlUtil.label(ConnexusLabels.PASSWORD_STRENGTH_TEXT),
            patterns: passwordPatterns,
            description: [
              { color: 'red', caption: IntlUtil.label(ConnexusLabels.PASSWORD_STRENGTH_BAD) },
              { color: 'red', caption: IntlUtil.label(ConnexusLabels.PASSWORD_STRENGTH_BAD) },
              { color: 'orange', caption: IntlUtil.label(ConnexusLabels.PASSWORD_STRENGTH_WEAK) },
              { color: 'yellow', caption: IntlUtil.label(ConnexusLabels.PASSWORD_STRENGTH_OKAY) },
              { color: 'green', caption: IntlUtil.label(ConnexusLabels.PASSWORD_STRENGTH_GOOD) },
            ],
          },
        }
        break

      case 'rating':
        ElementComponent = RatingField
        elementProps.data = data
        break

      case 'signature':
        ElementComponent = Signature
        elementProps.id = data.id
        elementProps.text = data.placeholder
        elementProps.required = data.required
        elementProps.errorText = data.errorText
        elementProps.data = data
        break

      case 'date':
        ElementComponent = TextInputField
        elementProps.data = {
          ...data,
          size,
        }
        break

      default: {
        ElementComponent = TextInputField
        elementProps.data = data
      }
    }

    return <ElementComponent {...otherProps} {...elementProps} />
  }

  _handleFieldFocus = () => {
    this.setState({ isInvalid: false, externalError: undefined })

    const { onFieldFocus } = this.props
    onFieldFocus && onFieldFocus()
  }

  checkValidity = () => {
    if (!this._ref) return true

    this._ref.blur && this._ref.blur()

    if (!this._ref.checkValidity) {
      return true
    }

    const isInvalid = !this._ref.checkValidity()

    this.setState({ isInvalid })
    return !isInvalid
  }

  getValue = () => {
    return this._ref && this._ref.getValue ? this._ref.getValue() : undefined
  }
}

const styles = ({ palette, spacing: { unit } }) => ({
  element: {
    width: '100%',
    '&:not(:last-child)': {
      marginBottom: unit,
    },
    '& > label': {
      color: palette.grey400 + '!important',
      width: '100%',
      minWidth: 400,
    },
  },
  textLine: {
    marginBottom: unit * 2,
  },
  smallButton: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
})

export default withStyles(styles)(FormElement)
